module.exports = __webpack_public_path__ + "img/logo_yundao.efdcb487.png";